import { z } from 'zod';
import { componentStyleSchema } from '../component-catalog.js';
const commonOptionals = {
    queryConfig: z.record(z.string(), z.unknown()).optional(),
    minimized: z.boolean().optional(),
    displayConfig: z.record(z.string(), z.unknown()).optional(),
    annotations: z.array(z.record(z.string(), z.unknown())).optional(),
    style: componentStyleSchema.optional(),
};
const propsSchema = z
    .object({
    sourceDataset: z.string(),
    mapping: z.object({ labels: z.string(), values: z.string() }).strict(),
    ...commonOptionals,
})
    .strict();
export const radarChartDefinition = {
    type: 'RadarChart',
    category: 'data',
    propsSchema,
    isDataBacked: true,
    columnRefManifest: ['labels', 'values'],
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Radar chart over a dataset. Props: sourceDataset (required), mapping ({ labels: string, values: string }).',
};
//# sourceMappingURL=RadarChart.js.map